import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
var SHELTERPOINT = window.SHELTERPOINT || {};
SHELTERPOINT.settings = SHELTERPOINT.settings || {};
SHELTERPOINT.settings = {

	"isDevice": false,
	'isMobileSize': false,
}



const deviceAgent = navigator.userAgent.toLowerCase();
const matchDevice = ( deviceAgent.match( /(iphone|ipod|ipad)/ )
|| deviceAgent.match( /(android)/ )
|| deviceAgent.match( /(iemobile)/ )
|| deviceAgent.match( /iphone/i )
|| deviceAgent.match( /ipad/i )
|| deviceAgent.match( /ipod/i )
|| deviceAgent.match( /blackberry/i )
|| deviceAgent.match( /bada/i ) );

/*
const isIE = deviceAgent.match( /(msie|trident|edge)/ );

if ( isIE ) {
	SHELTERPOINT.settings.isIE = true;
}

const isIOS = deviceAgent.match( /(iphone|ipod|ipad)/ );

if (isIOS) {
	SHELTERPOINT.settings.isIOS = true;
}
*/
//var msie = window.document.documentMode;//equals 11 on IE11, undefined on other browsers

SHELTERPOINT.settings.isDevice = Boolean( matchDevice );


SHELTERPOINT.setMobileSettings = function(){

	SHELTERPOINT.settings.isMobileSize = $('#mobile-sized').is(':visible');

}

SHELTERPOINT.init = function(){

	//all anchor tags 
	$("a").click(function(e){
		
		var href = $(this).attr('href');
		var title= $(this).data('title');
		
		if(href.indexOf('#') !== -1){
			var scrollHash = '#' + href.split('#')[1];
			//console.log('length',$(scrollHash).length);
			if ($(scrollHash).length > 0){
				e.preventDefault();
				//console.log(href,href.split('#'));
				//gsap.to(window, 1, {scrollTo:{y:scrollHash, offsetY:20}});
				gsap.to(window, 1, {scrollTo:{y:scrollHash}});
			}
		}
	});


	$(".burger").click(function(){
		$(this).toggleClass("open");
		$(".banner").toggleClass("open");
	})

	$(".banner a").click(function(){
		$(".banner, .burger").removeClass("open");
	})



	$(".shop-menu,.buy-now-menu").click(function(){
		$(this).toggleClass("active");
	})

	

  if (SHELTERPOINT.getCookie('ageverification') != "1"){

  	var modalHtml = SHELTERPOINT.ageVerificationHtml();

      $("body").append(modalHtml);

      setTimeout(function(){
        $(".age-verification-overlay").addClass('fadein');
      },500)

      $("body").attr("style","overflow:hidden");                

      $(".shelterpoint-button--accept").click(function(e){

        SHELTERPOINT.setCookie('ageverification','1',30);
        $(".age-verification-overlay").remove();
        $("body").attr("style","");

        //start timer for subscribe
        SHELTERPOINT.openSubscribeModal();

      });

      $(".shelterpoint-button--deny").click(function(e){

        $(".age-verification-warning").addClass('fadein');

      });
        

  }else{
  	SHELTERPOINT.openSubscribeModal();
  }





	// keep track of previous scroll position
	let prevScrollPos = window.pageYOffset;

	let hasClubExclusives = $('.club-exclusives').length > 0;
	let clubExclusiveTop = 0;
	let clubExclusiveHeight = 0;

	if (hasClubExclusives) {
		let clubExclusiveOffset = $('.club-exclusives').offset();
		clubExclusiveTop = clubExclusiveOffset ? clubExclusiveOffset.top : 0;
		clubExclusiveHeight = $('.club-exclusives').height();
	}

	window.addEventListener('scroll', function() {
	  // current scroll position
	  const currentScrollPos = window.pageYOffset;

		if (hasClubExclusives) {
			if (clubExclusiveTop  < currentScrollPos + ($(window).height()/2  - clubExclusiveHeight/2) && !SHELTERPOINT.settings.isMobileSize){
				$('.club-exclusives').addClass('fixed');
			}else{
				$('.club-exclusives').removeClass('fixed');
			}
		}

	  if (prevScrollPos > currentScrollPos) {
	    // user has scrolled up
	    $('.banner').addClass('fixed');
	  } else {
	    // user has scrolled down
	    $('.banner').removeClass('fixed');
	  }

	  // update previous scroll position
	  prevScrollPos = currentScrollPos;
	});



};


SHELTERPOINT.openSubscribeModal = function(){

	if (SHELTERPOINT.getCookie('subscribemodal') != "1"){
		//var modalHtml = $("#subscribe-overlay");
	  //$("body").append(modalHtml);
	  setTimeout(function(){
	    $("#subscribe-overlay").addClass('fadein');

	  	$("body").attr("style","overflow:hidden");
	  
	  },10000)

	  $("#subscribe-overlay .close,#subscribe-overlay .no-thanks").click(function(e){

	    e.preventDefault();
	    SHELTERPOINT.setCookie('subscribemodal','1',30);
	    $("#subscribe-overlay").remove();
	    $("body").attr("style","");

	  });

	}
}


SHELTERPOINT.elementSetup = function () {
	if ( SHELTERPOINT.settings.isDevice ) {
		$( "body" )
			.addClass( "device" );
	} else {
		$( "body" )
			.addClass( "desktop" );
	}

};



SHELTERPOINT.ageVerificationHtml = function () {

	var html = '<div class="age-verification-overlay"><div class="age-verification-overlay_inner">';
	html += '<h2>Shelter Point Distillery</h2><p>Age Verification</p><p>Are you over 19 years of age?</p>';
	html += '<div class="shelterpoint-button_row">';
	html += '<div class="shelterpoint-button shelterpoint-button--deny">No</div><div class="shelterpoint-button shelterpoint-button--accept">Yes</div>';
	html += '</div>';
	html += '<p class="age-verification-warning">You are not old enough to view this content.</p>';
	html += '</div></div>';

	return html;
};


SHELTERPOINT.setCookie = function(name,value,days){
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
SHELTERPOINT.getCookie = function(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
};
/*
SHELTERPOINT.eraseCookie = function(name) {   
  document.cookie = name+'=; Max-Age=-99999999;';  
};

*/

SHELTERPOINT.windowResize = function () {

	SHELTERPOINT.setMobileSettings();
	//SHELTERPOINT.addScrollTrigger();

};



$(document).ready(() => {

	SHELTERPOINT.elementSetup();

	SHELTERPOINT.setMobileSettings();

	SHELTERPOINT.init();

	//SHELTERPOINT.addScrollTrigger();

});


$(window).resize(function () {
    clearTimeout($.data(this, 'resizeTimer'));
    $.data(this, 'resizeTimer', setTimeout(function () {
        SHELTERPOINT.windowResize();
    }, 200));//don't fire too fast in case these functions do a lot of work

});